import {Component} from '@angular/core';
import {AccentComponent} from '@app/components/accent/accent.component';
import {Button, ButtonDirective} from 'primeng/button';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-event',
  imports: [
    Button,
    AccentComponent,
    ButtonDirective,
    RouterLink
  ],
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent {

}
